import * as React from "react";

function IcFlagCircularTh(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      data-id="IcFlagCircularTh"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <rect width={24} height={24} />
        <g fillRule="nonzero" transform="translate(2 2)">
          <path
            fill="#FFF"
            d="M0,10.0019493 C0,4.47910182 4.47593818,0.00194931774 10,0.00194931774 C15.5228475,0.00194931774 20,4.4778875 20,10.0019493 C20,15.5247968 15.5240618,20.0019493 10,20.0019493 C4.4771525,20.0019493 0,15.5260111 0,10.0019493 Z"
          />
          <path
            fill="#001B9A"
            d="M0.458308838,7 L19.5417277,7 C19.8394773,7.94755645 20,8.95596329 20,10.0019493 C20,11.0464379 19.8399096,12.0535253 19.5429154,13 L0.457048103,13 C0.160082786,12.0535764 0,11.0465009 0,10.0019493 C0,8.95602645 0.160530402,7.94760764 0.458308838,7 Z"
          />
          <path
            fill="#E70000"
            d="M2.85620471,17 L17.1437924,17 C15.3721091,18.8083922 12.9190727,19.9468081 10.1994901,20 L9.80052597,20 C7.08129472,19.9468109 4.62807114,18.808508 2.85620471,17 Z M17.1416939,3.00175439 L2.85830892,3.00175439 C4.67306101,1.15050646 7.20208904,0.00194931774 10,0.00194931774 C12.7975282,0.00194931774 15.326752,1.15038567 17.1416939,3.00175439 Z"
          />
        </g>
        <circle cx={12} cy={12} r={10} stroke={color} strokeWidth={2} />
      </g>
    </svg>
  );
}

export default IcFlagCircularTh;
